// src/routes/MainRoutes.jsx
import React, { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'component/Loadable';
import PrivateRoute from './PrivateRoute';
import EmployeePage from 'views/Kontak/Employee';
import CustomerPage from 'views/Kontak/Customer';
import VendorPage from 'views/Kontak/Vendor';
import VehicleCategoryPage from 'views/Master/VehicleCategory';
import OrderPage from 'views/Order/Order';
import OrderStatusPage from 'views/Order/OrderStatus';
import OrderInvoicePage from 'views/Order/OrderInvoice';
import ProfilePage from 'views/Login/Profile';
import CareerPage from 'views/Compro/Karir';
import CabinetPage from 'views/Document/Cabinet';
import DocumentCategoryPage from 'views/Document/DocumentCategories';
import DetailEdit from 'views/Compro/DetailEdit';
import DetailAdd from 'views/Compro/DetailAdd';
import DepartmentPage from 'views/Document/Department';
import JoblevelPage from 'views/Document/Joblevel';
import BisnisUnitDashPage from 'views/Document/BisnisUnitDash';
import JobleveldescriptionPage from 'views/Document/Jobleveldescription';
import OfficePage from 'views/Document/Office';
import DesignationDashPage from 'views/Document/Designation';
import AddEmployee from 'views/Kontak/AddEmployee';
import EditEmployee from 'views/Kontak/EditEmployee';
import ViewDocument from 'views/Document/ViewDocument';
import ViewEmployee from 'views/Kontak/ViewEmployee';
import BlogAdd from 'views/Compro/BlogAdd';
import BlogEdit from 'views/Compro/BlogEdit';
import AddBlogPostPage from 'views/Compro/BlogAdd';
import AddStudyPage from 'views/Compro/AddStudy';
import EditStudyPage from 'views/Compro/EditStudy';
import EditCareerPage from 'views/Compro/EditCareer';
import AddCareerPage from 'views/Compro/AddCareer';
import ViewCareerDetailPage from 'views/Compro/ViewCareer';
import VendorEdit from 'views/Kontak/VendorEdit';
import VendorAdd from 'views/Kontak/VendorAdd';
import ViewVendor from 'views/Kontak/ViewVendor';
import AddCustomer from 'views/Kontak/AddCustomer';
import EditCustomer from 'views/Kontak/EditCustomer';
import ViewCustomer from 'views/Kontak/ViewCustomer';
import CategoryCoursePage from 'views/Academy/CourseCategory';
import CoursePage from 'views/Academy/Courses';
import ProgressPage from 'views/Academy/Progress';
import CertificatePage from 'views/Academy/Certificate';
import CourseDetails from 'views/Academy/CourseDetails';
import QuizPage from 'views/Academy/CourseQuiz';
import QuizOptionPage from 'views/Academy/quizOption';
import WrongAnswersTable from 'views/Academy/ViewProgress';
import CandidatePage from 'views/Kontak/Candidate';
import ViewCandidate from 'views/Kontak/ViewCandidate';
import AddCandidate from 'views/Kontak/AddCandidate';
import EditCandidate from 'views/Kontak/EditCandidate';
import MeetingPage from 'views/Kontak/Meeting';
import AddMeeting from 'views/Kontak/AddMeeting';
import EditMeeting from 'views/Kontak/EditMeeting';
import ViewMeeting from 'views/Kontak/ViewMeeting';
import ViewEmployeeStatic from 'views/Kontak/ViewEmployeeStatic';
import AddEmployeeStatic from 'views/Kontak/AddEmployeeStatic';
import EditEmployeeStatic from 'views/Kontak/EditEmployeeStatic';

// Absensi, Payroll, Penilaian Kinerja, Self Service
import AbsensiPage from 'views/Absensi';
import ViewAbsensi from 'views/Absensi/ViewAbsensi';
import PayrollPage from 'views/Payroll';
import ViewPayroll from 'views/Payroll/ViewPayroll';
import PenilaianKinerjaPage from 'views/PenilaianKinerja';
import ViewPenilaianKinerja from 'views/PenilaianKinerja/ViewPenilaianKinerja';
import SelfServicePage from 'views/SelfService';
import ViewSelfService from 'views/SelfService/ViewSelfService';

// Form Pengajuan pages (header-only)
import PermintaanSDM from 'views/FormPengajuan/PermintaanSDM';
import Kesehatan from 'views/FormPengajuan/Kesehatan';
import Promosi from 'views/FormPengajuan/Promosi';
import Demosi from 'views/FormPengajuan/Demosi';
import Mutasi from 'views/FormPengajuan/Mutasi';
import KenaikanGaji from 'views/FormPengajuan/KenaikanGaji';
import Pengangkatan from 'views/FormPengajuan/Pengangkatan';
import PerpanjanganKontrak from 'views/FormPengajuan/PerpanjanganKontrak';
import PemutusanKontrak from 'views/FormPengajuan/PemutusanKontrak';
import Cuti from 'views/FormPengajuan/Cuti';
import PerjalananDinas from 'views/FormPengajuan/PerjalananDinas';
import PerjalananDinasTraining from 'views/FormPengajuan/PerjalananDinasTraining';
import KeteranganTidakAbsen from 'views/FormPengajuan/KeteranganTidakAbsen';
import IzinTidakMasuk from 'views/FormPengajuan/IzinTidakMasuk';
import Pelatihan from 'views/FormPengajuan/Pelatihan';
import PengunduranDiri from 'views/FormPengajuan/PengunduranDiri';
import PHKPensiun from 'views/FormPengajuan/PHKPensiun';
import RekomendasiKaryawanKeluar from 'views/FormPengajuan/RekomendasiKaryawanKeluar';
// SSO Management imports
import ClientPage from 'views/SSO/Client';
import AddClient from 'views/SSO/Client/AddClient';
import EditClient from 'views/SSO/Client/EditClient';
import ViewClient from 'views/SSO/Client/ViewClient';
import UserPage from 'views/SSO/User';
import AddUser from 'views/SSO/User/AddUser';
import EditUser from 'views/SSO/User/EditUser';
import ViewUser from 'views/SSO/User/ViewUser';
import UserRolePage from 'views/SSO/UserRole';
import AddUserRole from 'views/SSO/UserRole/AddUserRole';
import EditUserRole from 'views/SSO/UserRole/EditUserRole';
import ViewUserRole from 'views/SSO/UserRole/ViewUserRole';
import PrintCandidate from 'views/Utils/PrintCandidate';
import PrintEmployee from 'views/Utils/PrintEmployee';
// Eureka Plus imports
import ExternalCustomersPage from 'views/EurekaPlus/ExternalCustomers';
import ExternalTransactionsPage from 'views/EurekaPlus/ExternalTransactions';
import ExternalCustomerDetailPage from 'views/EurekaPlus/ExternalCustomerDetail';
import ExternalTransactionDetailPage from 'views/EurekaPlus/ExternalTransactionDetail';
import PelatihanHistory from 'views/Pelatihan/History';
import PelatihanCatalog from 'views/Pelatihan/Catalog';
import PelatihanKurikulum from 'views/Pelatihan/Kurikulum';

// Lazy-load untuk komponen halaman
const DashboardDefault = Loadable(lazy(() => import('views/Dashboard/Default')));
const EmployeeDashboard = Loadable(lazy(() => import('views/Dashboard/EmployeeDashboard')));
const Overview = Loadable(lazy(() => import('views/Dashboard/Overview')));
const ErrorBoundary = Loadable(lazy(() => import('component/ErrorBoundary')));

// Import semua halaman lainnya seperti yang sudah ada di kode sebelumnya
const SalesPage = Loadable(lazy(() => import('views/Kontak/SalesPage')));
const SupplierPage = Loadable(lazy(() => import('views/Kontak/SupplierPage')));
const BuPage = Loadable(lazy(() => import('views/Master/Bu')));
const BuBrenchPage = Loadable(lazy(() => import('views/Master/BuBrench')));
const VehiclePage = Loadable(lazy(() => import('views/Master/Vehicle')));
const VehicleLocationPage = Loadable(lazy(() => import('views/Master/VehicleLocation')));
const PoolPage = Loadable(lazy(() => import('views/Master/Pool')));
const DriverPage = Loadable(lazy(() => import('views/Master/Driver')));
const EmployeePositionPage = Loadable(lazy(() => import('views/Master/EmployeePosition')));
const SubdistrictPage = Loadable(lazy(() => import('views/Wilayah/Subdistrict')));
const CityPage = Loadable(lazy(() => import('views/Wilayah/City')));
const ProvincePage = Loadable(lazy(() => import('views/Wilayah/Province')));
const CountryPage = Loadable(lazy(() => import('views/Wilayah/Country')));
const RoutePage = Loadable(lazy(() => import('views/Logistics/Route')));
const VehicleTimelinePage = Loadable(lazy(() => import('views/Logistics/VehicleTimeline')));
const OrderDetailPage = Loadable(lazy(() => import('views/Order/OrderDetail')));
const OrderTotalPage = Loadable(lazy(() => import('views/Order/OrderTotal')));
const OrderHistoryPage = Loadable(lazy(() => import('views/Order/OrderHistory')));
const OrderInvoiceDetailPage = Loadable(lazy(() => import('views/Order/OrderInvoiceDetail')));
const LoseSalesPage = Loadable(lazy(() => import('views/Order/LostSales')));
const StudyCasePage = Loadable(lazy(() => import('views/Compro/StudyCase')));
const BlogPostPage = Loadable(lazy(() => import('views/Compro/BlogPost')));
const BisnisUnitManagement = Loadable(lazy(() => import('views/Compro/BisnisUnitManagement')));
const AuthorPage = Loadable(lazy(() => import('views/Compro/Author')));
const BisnisUnitDetail = Loadable(lazy(() => import('views/Compro/BisnisUnitDetail')));
const PromoPage = Loadable(lazy(() => import('views/Compro/Promo')));
const DocumentPage = Loadable(lazy(() => import('views/Document/Document')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  element: <PrivateRoute><MainLayout /></PrivateRoute>,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: '/dashboard',
      element: <ErrorBoundary><EmployeeDashboard /></ErrorBoundary>
    },
    {
      path: '/overview',
      element: <ErrorBoundary><Overview /></ErrorBoundary>
    },

    { path: '/profile', element: <ProfilePage /> },
    // Routes for KONTAK menu
    { path: '/kontak/customer', element: <CustomerPage /> },
    { path: '/kontak/customer/add', element: <AddCustomer /> },
    { path: '/kontak/customer/edit/:id', element: <EditCustomer /> },
    { path: '/kontak/customer/view/:id', element: <ViewCustomer /> },
    { path: '/kontak/candidate', element: <CandidatePage /> },
    { path: '/kontak/candidate/add', element: <AddCandidate /> },
    { path: '/kontak/candidate/edit/:id', element: <EditCandidate /> },
    { path: '/kontak/candidate/view/:id', element: <ViewCandidate /> },
  { path: '/kontak/meeting', element: <MeetingPage /> },
  { path: '/kontak/meeting/add', element: <AddMeeting /> },
  { path: '/kontak/meeting/edit/:id', element: <EditMeeting /> },
  { path: '/kontak/meeting/view/:id', element: <ViewMeeting /> },
    { path: '/kontak/vendor', element: <VendorPage /> },
    { path: '/kontak/vendor/add', element: <VendorAdd /> },
    { path: '/kontak/vendor/edit/:id', element: <VendorEdit /> },
    { path: '/kontak/vendor/view/:id', element: <ViewVendor /> },
    { path: '/kontak/employee', element: <EmployeePage /> },
    { path: '/kontak/employee/ViewEmployee/:id', element: <ViewEmployee /> },
    { path: '/kontak/employee/add', element: <AddEmployee /> },
    { path: '/kontak/employee/EditEmployee/:id', element: <EditEmployee /> },
    // Print routes (persist on refresh)
    { path: '/print/candidate/:id', element: <PrintCandidate /> },
    { path: '/print/employee/:id', element: <PrintEmployee /> },
    // Static Employee Routes
    { path: '/kontak/employee/view-static/:id', element: <ViewEmployeeStatic /> },
    { path: '/kontak/employee/add-static', element: <AddEmployeeStatic /> },
    { path: '/kontak/employee/edit-static/:id', element: <EditEmployeeStatic /> },
    { path: '/kontak/employee-sales', element: <SalesPage /> },
    { path: '/kontak/supplier', element: <SupplierPage /> },

    // Routes for SSO Management menu
    { path: '/sso/client', element: <ClientPage /> },
    { path: '/sso/client/add', element: <AddClient /> },
    { path: '/sso/client/edit/:id', element: <EditClient /> },
    { path: '/sso/client/view/:id', element: <ViewClient /> },
    { path: '/sso/user', element: <UserPage /> },
    { path: '/sso/user/add', element: <AddUser /> },
    { path: '/sso/user/edit/:id', element: <EditUser /> },
    { path: '/sso/user/view/:id', element: <ViewUser /> },
    { path: '/sso/user-role', element: <UserRolePage /> },
    { path: '/sso/user-role/add', element: <AddUserRole /> },
    { path: '/sso/user-role/edit/:id', element: <EditUserRole /> },
    { path: '/sso/user-role/view/:id', element: <ViewUserRole /> },

  // Routes for Pelatihan (Kepelatihan)
  { path: '/pelatihan/history', element: <PelatihanHistory /> },
  { path: '/pelatihan/catalog', element: <PelatihanCatalog /> },
  { path: '/pelatihan/kurikulum', element: <PelatihanKurikulum /> },

    // Routes for MASTER menu
    { path: '/master/bu', element: <BuPage /> },
    { path: '/master/bu-brench', element: <BuBrenchPage /> },
    { path: '/master/vehicle', element: <VehiclePage /> },
    { path: '/master/vehicle-location', element: <VehicleLocationPage /> },
    { path: '/master/vehicle-category', element: <VehicleCategoryPage /> },
    { path: '/master/pool', element: <PoolPage /> },
    { path: '/master/driver', element: <DriverPage /> },
    { path: '/master/employee-position', element: <EmployeePositionPage /> },

    // Routes for WILAYAH menu
    { path: '/wilayah/subdistrict', element: <SubdistrictPage /> },
    { path: '/wilayah/city', element: <CityPage /> },
    { path: '/wilayah/province', element: <ProvincePage /> },

    // Routes for Logistics menu
    { path: '/logistics/route', element: <RoutePage /> },
    { path: '/logistics/vehicle-timeline', element: <VehicleTimelinePage /> },

    // Routes for ORDER menu
    { path: '/order', element: <OrderPage /> },
    { path: '/order/order-detail/:orderId', element: <OrderDetailPage /> },
    { path: '/order/order-status', element: <OrderStatusPage /> },
    { path: '/order/order-total', element: <OrderTotalPage /> },
    { path: '/order/order-history', element: <OrderHistoryPage /> },
    { path: '/order/order-invoice', element: <OrderInvoicePage /> },
    { path: '/order/order-invoice-detail/:id', element: <OrderInvoiceDetailPage /> },
    { path: '/order/lose-sales', element: <LoseSalesPage /> },
    
    // Routes for Company Profile menu
    { path: '/compro/study-case', element: <StudyCasePage /> },
    { path: '/compro/study-case/add', element: <AddStudyPage /> },
    { path: '/compro/study-case/edit/:id', element: <EditStudyPage /> },
    { path: '/compro/blog-post', element: <BlogPostPage /> },
    { path: '/compro/blog-post/add', element: <AddBlogPostPage /> },
    { path: '/compro/blog-post/edit/:id', element: <BlogEdit /> },
    { path: '/compro/Bisnis-Unit-Management', element: <BisnisUnitManagement /> },
    { path: '/compro/author', element: <AuthorPage /> },
    { path: '/compro/career', element: <CareerPage /> },
    { path: '/compro/career/add', element: <AddCareerPage /> },
    { path: '/compro/career/edit/:id', element: <EditCareerPage /> },
    { path: '/compro/career/view/:id', element: <ViewCareerDetailPage /> },
    { path: '/compro/Bisnis-Unit-Detail', element: <BisnisUnitDetail /> },
    { path: '/compro/promo', element: <PromoPage /> },
    { path: '/compro/Detail-Add', element: <DetailAdd /> },
    { path: '/compro/BisnisUnitPage/edit/:title_banner', element: <DetailEdit /> },

    // Routes for Absensi, Payroll, Penilaian Kinerja, Self-service
    { path: '/absensi', element: <AbsensiPage /> },
    { path: '/absensi/view/:id', element: <ViewAbsensi /> },
    { path: '/payroll', element: <PayrollPage /> },
    { path: '/payroll/view/:id', element: <ViewPayroll /> },
    { path: '/penilaian-kinerja', element: <PenilaianKinerjaPage /> },
    { path: '/penilaian-kinerja/view/:id', element: <ViewPenilaianKinerja /> },
    { path: '/self-service', element: <SelfServicePage /> },
    { path: '/self-service/view/:id', element: <ViewSelfService /> },

    // Routes for Form Pengajuan
    { path: '/form-pengajuan/permintaan-sdm', element: <PermintaanSDM /> },
    { path: '/form-pengajuan/kesehatan', element: <Kesehatan /> },
    { path: '/form-pengajuan/promosi', element: <Promosi /> },
    { path: '/form-pengajuan/demosi', element: <Demosi /> },
    { path: '/form-pengajuan/mutasi', element: <Mutasi /> },
    { path: '/form-pengajuan/kenaikan-gaji', element: <KenaikanGaji /> },
    { path: '/form-pengajuan/pengangkatan', element: <Pengangkatan /> },
    { path: '/form-pengajuan/perpanjangan-kontrak', element: <PerpanjanganKontrak /> },
    { path: '/form-pengajuan/pemutusan-kontrak', element: <PemutusanKontrak /> },
    { path: '/form-pengajuan/cuti', element: <Cuti /> },
    { path: '/form-pengajuan/perjalanan-dinas', element: <PerjalananDinas /> },
    { path: '/form-pengajuan/perjalanan-dinas-training', element: <PerjalananDinasTraining /> },
    { path: '/form-pengajuan/keterangan-tidak-absen', element: <KeteranganTidakAbsen /> },
    { path: '/form-pengajuan/izin-tidak-masuk', element: <IzinTidakMasuk /> },
    { path: '/form-pengajuan/pelatihan', element: <Pelatihan /> },
    { path: '/form-pengajuan/pengunduran-diri', element: <PengunduranDiri /> },
    { path: '/form-pengajuan/phk-pensiun', element: <PHKPensiun /> },
    { path: '/form-pengajuan/rekomendasi-karyawan-keluar', element: <RekomendasiKaryawanKeluar /> },

    //Routes for Document Menu
    { path: '/document', element: <DocumentPage /> },
    { path: '/document/ViewDocument/:id', element: <ViewDocument /> },
    { path: '/document/cabinet', element: <CabinetPage /> },
    { path: '/document/document-category', element: <DocumentCategoryPage /> },
    { path: '/document/Department', element: <DepartmentPage /> },
    { path: '/document/Designation', element: <DesignationDashPage /> },
    { path: '/document/Job-level', element: <JoblevelPage /> },
    { path: '/document/Bisnis-Unit', element: <BisnisUnitDashPage /> },
    { path: '/document/Office', element: <OfficePage /> },
    { path: '/document/Job-level-description', element: <JobleveldescriptionPage /> },

    //Routes for Document Menu
    { path: '/academy/course-category', element: <CategoryCoursePage /> },
    { path: '/academy/courses', element: <CoursePage /> },
    { path: '/academy/course-details', element: <CourseDetails /> },
    { path: '/academy/course-quiz', element: <QuizPage /> },
    { path: '/academy/course-quiz-options', element: <QuizOptionPage /> },
    { path: '/academy/progress', element: <ProgressPage /> },
    { path: '/academy/certificate', element: <CertificatePage /> },
    { path: '/academy/view-progress/:idEmployee/:idCourse', element: <WrongAnswersTable /> },

    // Routes for Eureka Plus menu
    { path: '/eureka-plus/external-customers', element: <ExternalCustomersPage /> },
    { path: '/eureka-plus/external-customers/view/:id', element: <ExternalCustomerDetailPage /> },
    { path: '/eureka-plus/external-transactions', element: <ExternalTransactionsPage /> },
    { path: '/eureka-plus/external-transactions/view/:id', element: <ExternalTransactionDetailPage /> },
  ]
};

export default MainRoutes;
